import { useModal } from "@/components/_primitives/Modal/ModalRoot/ModalRoot";
import { Button } from "@/components/Global/Button/Button";
import { useAppContext } from "@/context/AppContext";
import { addToShoppingList } from "@/utils/serviceAPI/shoppinglist";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React from "react";
import { toast } from "react-toastify";

function ShoppingListButton({
  recipeId,
  recipeTitle,
  className,
}: {
  recipeId: number;
  recipeTitle: string;
  className?: string;
}) {
  const { getLabel } = useGlobalContext();
  const { user, setShoppingList, setFormModalText } = useAppContext();
  const { setOpen } = useModal();

  async function handleAdd(recipeId: number) {
    if (!user) {
      setOpen(true);
      setFormModalText(getLabel("shopping_list_user_not_found"));
    } else {
      const res = await addToShoppingList(recipeId);
      if (res) {
        toast(getLabel("shopping_list_recipe_added"));
        setShoppingList();
      } else {
        toast(getLabel("shopping_list_recipe_already_added"));
      }
    }
  }

  return (
    <Button
      className={`ghost ${className || ""}`}
      type="primary"
      href="#"
      target={""}
      onClick={() => handleAdd(recipeId)}
      aria-label={getLabel("aria_label_shopping_list_button").replace(
        "$$title",
        recipeTitle,
      )}
    >
      {getLabel("shopping_list_button")}
    </Button>
  );
}

export default ShoppingListButton;
